import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getCountries } from "../services/countries";

export default function CountrySelect({
  value,
  onChange,
  required = false,
  fullWidth = true,
  label = "Country",
}) {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCountries()
      .then(setCountries)
      .finally(() => setLoading(false));
  }, []);

  const selected = countries.find((country) => country._id === value) ?? null;

  return (
    <Autocomplete
      fullWidth={fullWidth}
      options={countries}
      loading={loading}
      value={selected}
      getOptionLabel={(option) => option.name ?? ""}
      isOptionEqualToValue={(option, val) => option._id === val._id}
      onChange={(_, newValue) => onChange(newValue?._id ?? "")}
      renderInput={(params) => (
        <TextField {...params} label={label} required={required} />
      )}
    />
  );
}
